import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';

export default function CreateListingSuccessControls({ listing, onClose }) {
  return <React.Fragment>
    <Button label="Close" variant="ghost" onClick={onClose} />

    <a className="ml-2" href={listing.path}>
      <Button label="Edit Listing" />
    </a>
  </React.Fragment>;
}

CreateListingSuccessControls.propTypes = {
  listing: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
